import { make } from 'vuex-pathify';
import { includes, isEqual, keyBy, keys, shuffle } from 'lodash';

const threats = keyBy(
    [
        {
            id: 1,
            text: 'You pass out and don’t know what happened, but you’re now super worried about HIV and STIs!',
            correctAnswers: ['Alcohol', 'Pot'],
            answers: []
        },
        {
            id: 2,
            text: 'You forgot where you put the condoms or whether you brought them!',
            correctAnswers: ['Alcohol', 'Pot'],
            answers: []
        },
        {
            id: 3,
            text: 'You meant to hook up with one person, but were so amped up that you had sex with lots of people.',
            correctAnswers: ['Cocaine or Crack', 'Crystal meth', 'Ecstasy'],
            answers: []
        },
        {
            id: 4,
            text: 'You had sex more times than you thought you would (or could!) and ran out of condoms.',
            correctAnswers: ['Crystal meth', 'Poppers', 'Ecstasy'],
            answers: []
        },
        {
            id: 5,
            text: 'You wanted to get loose before sex, but ended up painful, bleeding and sore',
            correctAnswers: ['Poppers'],
            answers: []
        }
    ],
    'id'
);
const threatsOrder = shuffle(keys(threats)); // shuffle once, on module creation
const currentThreat = 0;
const substances = ['Alcohol', 'Pot', 'Cocaine or Crack', 'Crystal meth', 'Poppers', 'Ecstasy'];

const state = {
    title: 'In the Mix',
    complete: false,
    sticker: {
        text: 'Salad bowl',
        earned: false,
        image: require('@/assets/stickers/stickers_0016_salad.png')
    },
    bonusSticker: false,
    trophy: false,
    threats,
    threatsOrder,
    currentThreat,
    substances
};
const getters = {
    ...make.getters(state),
    allThreatsAnswered: state => {
        return state.currentThreat >= state.threatsOrder.length;
    }
};
const mutations = {
    ...make.mutations(state),
    answerThreat(state, substance) {
        const threat = state.threats[state.threatsOrder[state.currentThreat]];
        if (includes(threat.correctAnswers, substance) && !includes(threat.answers, substance)) {
            threat.answers.push(substance);
        }
        if (isEqual(threat.correctAnswers.sort(), threat.answers.sort())) {
            state.currentThreat++;
        }
    }
};
const actions = make.actions(state);

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
